import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Chart, Geom, Axis, Tooltip, Coord, Guide } from 'bizcharts';
import DataSet from '@antv/data-set';
import { Spin, Result, Input, Button } from 'antd';
import { message, Timeline, Cascader, Modal, Icon } from 'antd';
import './barCharts.css';
import qs from 'query-string';
import { apis } from '../../api/index.js';
import i18n from 'i18next';
import { updateUploadList, formatDA } from '../../utils';
import btnSubmit from '../../imgs/btn-submit.png';
import ConnectedPrintReport from '../../previewReport/ConnectedPrintReport.js';
import ConnectedAiReport from './ConnectedAiReport.js';
import ConnectedScreening from './ConnectedScreening.js';
import ConnectedImageQC from './ConnectedImageQC.js';
import ReactToPrint from 'react-to-print';
import { shalouIcon } from '../../utils';
import classNames from 'classnames';

const { Line } = Guide;
const { confirm } = Modal;

const center = { text: '中风险', color: 'orange' };
const low = { text: '低风险', color: 'green' };
const high = { text: '高风险', color: 'red' };
const loading = { text: '加载中', color: 'white' };
class BarCharts extends Component {
  static propTypes = {
    imageReady: PropTypes.bool.isRequired,
    scoresData: PropTypes.object,
    setScoresData: PropTypes.func.isRequired,
    objectUid: PropTypes.string,
    setHeatmapContext: PropTypes.func,
    context: PropTypes.object.isRequired,
    thumbIndex: PropTypes.number,
    aiReportChanged: PropTypes.func,
    dicomIds: PropTypes.array,
    selectedData: PropTypes.array,
    history: PropTypes.object,
    showHeatMap: PropTypes.func,
    showScreening: PropTypes.bool,
    detailList4StudyImgList: PropTypes.array,
    tubeStudyDetail: PropTypes.object,
    applicationInfo: PropTypes.object,
    followupList: PropTypes.array,
  };

  promises = new Map();

  constructor(props) {
    super(props);
    const search = qs.parse(window.location.search);
    this.state = {
      id: search.id,
      textAreaValue: '',
      type: search.type,
      canReview: false,
      canSeeReview: true,
      reviewDoctorName: '',
      reviewRecordHis: [],
      reviewHistoryToggle: false,
      qcResult: {},
      doctorConfigs: [],
      index: 0,
      reviewRes: [],
      token: search.token,
      from: search.from,
      status: 0,
      addMoreReview: false,
      isOtherBody: search.isOtherBody,
      from1: search.from1,
      detailList4StudyImgList: [],
      report: {},
      isLoading: false,
      canPrint: true,
    };

    this.keyLabelMap = {
      tuberculosis: 'tuberculosis',
      cancer: 'cancer',
      pneumonia: 'pneumonia',
      pleural_disease: 'pleural_disease',
      abnormal: 'abnormal',
      viral_pneumonia: 'viralPneumonia',
      seventh_cervical_vertebra: 'vertebraNotIncluded',
      left_costophrenic_angle: 'costophrenicLNotIncluded',
      right_costophrenic_angle: 'costophrenicRNotIncluded',
      foreign_body: 'foreignObject',
      chest_pa: 'chestPA',
      chest_lat: '侧位',
      chest_obl: '斜位',
      not_chest: '非胸片',
      overexposure: 'overPenetration',
      underexposure: 'underPenetration',
      old_tuberculosis: 'old_tuberculosis',
      image_blur: 'imageBlur',
      left_apex: '左肺尖',
      right_apex: '右肺尖',
    };
  }

  getAiScores = () => {
    const { imageReady, objectUid, scoresData } = this.props;
    if (imageReady && objectUid && !this.promises.has(objectUid)) {
      let data = window.store.getState().api.resource.resource || {};
      data.context = data.context || {};
      const status = data.context.aiStatus;
      if (status === '200') {
        const scoresList = data.resultAllFinding.resultOneFinding;
        if (scoresList.length === 0) return;
        const scores = [];
        scoresList.forEach(item => {
          scores.push({
            type_name: item.name,
            confidence: Math.round(item.confidence * 100),
          });
        });
        this.props.setScoresData({
          ...scoresData,
          objectUid,
          scores,
          loading: false,
        });
      } else {
        this.props.setScoresData({
          ...scoresData,
          objectUid,
          error: data.context.aiMessage,
          loading: false,
        });
      }

      this.promises.set(objectUid, 1);
    }
  };

  // 胸片AI质控bar配置
  getQCScores = scores => {
    let data8 = [];
    const types = [
      'left_apex',
      'right_apex',
      'seventh_cervical_vertebra',
      'left_costophrenic_angle',
      'right_costophrenic_angle',
      'foreign_body',
      'overexposure',
      'underexposure',
      'image_blur',
    ];
    const oppositeTypes = [
      'left_apex',
      'right_apex',
      'seventh_cervical_vertebra',
      'left_costophrenic_angle',
      'right_costophrenic_angle',
    ];

    scores.forEach(s => {
      if (types.indexOf(s.type_name) >= 0) {
        const name = i18n.t(this.keyLabelMap[s.type_name]);
        const isOpposite = oppositeTypes.indexOf(s.type_name) >= 0;
        data8.push({
          type: name + (isOpposite ? i18n.t('notInclued') : ''),
          value: isOpposite ? 100 - s.confidence : s.confidence,
          name: s.type_name,
        });
      }
    });
    return data8;
  };

  // 常见肺部疾病bar配置 || demo疾病子服务
  getDiseaseScores = scores => {
    const types = [
      'tuberculosis',
      'cancer',
      'pneumonia',
      'pleural_disease',
      'abnormal',
    ];
    const { from } = this.state;
    let data9 = [];
    scores.forEach(s => {
      let name, confidence;
      if (from === 'aiproduct') {
        name = s.name;
        confidence = Math.round(s.confidence * 100);
      } else {
        name = s.type_name;
        confidence = s.confidence;
      }
      if (types.indexOf(name) >= 0) {
        data9.push({
          type: i18n.t(this.keyLabelMap[name]),
          value: confidence,
          name,
        });
      }
    });
    return data9;
  };

  // 病毒性肺炎bar配置
  getViralPneumoniaScores = scores => {
    const types = ['viral_pneumonia', 'abnormal'];
    let data6 = [];
    const { from } = this.state;
    scores.forEach(s => {
      let name, confidence;
      if (from === 'aiproduct') {
        name = s.name;
        confidence = Math.round(s.confidence * 100);
      } else {
        name = s.type_name;
        confidence = s.confidence;
      }
      if (types.indexOf(name) >= 0) {
        data6.push({
          type: i18n.t(this.keyLabelMap[name]),
          value: confidence,
          name: name,
        });
      }
    });
    return data6;
  };

  // 肺结核bar配置
  getTuberculosisScores = scores => {
    //old_tuberculosis abnormal
    //中眸机构id
    const institutionIds = [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
    const applicationInfo =
      window.store.getState().api.current.applicationInfo || {};
    const currentInstitutionId = applicationInfo.institutionId;
    const { from } = this.state;
    const types = ['tuberculosis'];
    if (institutionIds.indexOf(currentInstitutionId) >= 0) {
      types.push('old_tuberculosis');
      types.push('abnormal');
    }
    let data11 = [];
    scores.forEach(s => {
      const name = from === 'aiproduct' ? s.name : s.type_name;

      if (types.indexOf(name) >= 0) {
        let num = s.confidence;
        let value = from === 'aiproduct' ? Math.round(num * 100) : num;

        const keyName = this.keyLabelMap[name];
        const typeCode = keyName === 'tuberculosis' ? 'tuberculosis1' : keyName;
        data11.push({ type: i18n.t(typeCode), value, name: name });
      }
    });
    return data11;
  };

  //demo质控子服务
  getQCDemoScores = scores => {
    const types = [
      'seventh_cervical_vertebra',
      'left_costophrenic_angle',
      'right_costophrenic_angle',
      'abnormal',
    ];
    let data2 = [];
    scores.forEach(s => {
      if (types.indexOf(s.type_name) >= 0) {
        data2.push({
          type: i18n.t(this.keyLabelMap[s.type_name]),
          value: s.confidence,
          name: s.type_name,
        });
      }
    });
    return data2;
  };

  //demo体外异物服务
  getForeignBodyScores = scores => {
    const types = ['foreign_body'];
    let data3 = [];
    scores.forEach(s => {
      if (types.indexOf(s.type_name) >= 0) {
        data3.push({
          type: i18n.t(this.keyLabelMap[s.type_name]),
          value: s.confidence,
          name: s.type_name,
        });
      }
    });
    return data3;
  };

  //demo正侧位
  getChestScores = scores => {
    const types = ['chest_pa', 'chest_lat', 'chest_obl', 'not_chest'];
    let data4 = [];
    scores.forEach(s => {
      if (types.indexOf(s.type_name) >= 0) {
        data4.push({
          type: i18n.t(this.keyLabelMap[s.type_name]),
          value: s.confidence,
          name: s.type_name,
        });
      }
    });
    return data4;
  };

  getDemoScores = scores => {
    let data = [];
    scores.forEach(s => {
      data.push({
        type: i18n.t(this.keyLabelMap[s.type_name]),
        value: s.confidence,
        name: s.type_name,
      });
    });
    return data;
  };

  getDataView = () => {
    const { type, from } = this.state;
    const { scoresData } = this.props;
    if (scoresData && (from === 'aiproduct' || scoresData.scores)) {
      let scores = scoresData.scores || [];
      let data = [];
      if (type === '6') data = this.getViralPneumoniaScores(scores);
      else if (type === '8') data = this.getQCScores(scores);
      else if (type === '9') data = this.getDiseaseScores(scores);
      else if (type === '11') data = this.getTuberculosisScores(scores);
      else data = this.getDemoScores(scores);
      const ds = new DataSet();
      return ds
        .createView()
        .source(data)
        .transform({ type: 'sort-by', fields: ['value'] });
    }
  };
  componentDidUpdate(prevProps) {
    this.getAiScores();
    const { detailList4StudyImgList } = this.props;
    if (detailList4StudyImgList !== prevProps.detailList4StudyImgList) {
      const imageList = { imgList: detailList4StudyImgList };
      this.setState({
        report: { ...this.state.report, ...imageList },
      });
    }
  }

  componentDidMount() {
    const { id, type } = this.state;
    if (id && type) {
      this.getDoctorReviewRecord();
      this.getDoctorReviewRecordHis();
      this.setPrintContent();
    }

    this.getQCResult();
    this.getDoctorConfigs();
  }

  componentWillUnmount() {
    this.promises.clear();
  }

  getQCResult = () => {
    const { type, id } = this.state;
    if (type === '8' && id) {
      apis.qcResult(id).then(res => {
        if (res.code === '0') {
          this.setState({ qcResult: res.data });
        } else {
          message.error(res.message);
          if (res.code === '1009') this.props.history.push('/login');
        }
      });
    }
  };

  getDoctorConfigs = () => {
    apis.getDoctorConfigs().then(res => {
      if (res.code === '0') {
        this.setState({ doctorConfigs: res.data });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  saveReview = () => {
    const { reviewRes, token, from, id, type } = this.state;
    let res = [],
      flag = false;
    reviewRes.forEach(item => {
      if (item.value.length === 0 || item.value[1] === 0) flag = true;
      res.push(item.value[1]);
    });

    if (reviewRes.length === 0) {
      message.error('请在专家审核选择审核建议!', 2);
      return;
    }
    if (flag) {
      message.error('审核结果存在未确认的项，请核对后再提交', 2);
      return;
    }
    let post = {},
      url;
    if (token) post.token = token;
    if (from === 'aiproduct') {
      post.studyDrId = this.state.id;
      post.doctorResult = res.join(',');
      post.doctorRemark = encodeURI(this.state.textAreaValue) || ' ';
      url = apis.doctorReview4Study(post);
    } else {
      post.dicomDrId = this.state.id;
      post.aiProductType = this.state.type;
      post.doctorResult = res.join(',');
      post.doctorRemark = encodeURI(this.state.textAreaValue) || ' ';
      url = apis.doctorReview(post);
    }

    this.setState({ isLoading: true });
    url.then(result => {
      this.setState({ isLoading: false });
      if (result.code === '0') {
        message.success(result.data, 2);
        if (id && type) {
          this.getDoctorReviewRecord();
          this.getDoctorReviewRecordHis();
          this.setPrintContent();
        }

        updateUploadList();
      } else {
        if (result.code === '1009') this.props.history.push('/login');
        message.error(result.message, 2);
      }
    });
  };

  giveupReview = () => {
    const _this = this;
    const { id, from } = this.state;
    confirm({
      title: '提示',
      content: '是否确认放弃审核，放弃后将由其他医生进行审核',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        _this.setState({ isLoading: true });
        let url;
        if (from === 'aiproduct') url = apis.setDoctorReviewStatus4Study(id, 0);
        else url = apis.setDoctorReviewStatus(id, 0);

        url.then(res => {
          _this.setState({ isLoading: false });
          if (res.code === '0') {
            updateUploadList();
            message.success('操作成功');
            window.close();
          } else {
            message.error(res.message);
            if (res.code === '1009') _this.props.history.push('/login');
          }
        });
      },
    });
  };

  textAreaOnChange = e => {
    this.setState({ textAreaValue: e.target.value });
  };

  getDoctorReviewRecord = () => {
    const { token, id, type, from } = this.state;
    let [post, url] = [{}, ''];
    if (token) post.token = token;
    if (from === 'aiproduct') {
      post = { ...post, id };
      url = apis.doctorReviewRecord4Study(post);
    } else {
      post = { ...post, dicomDrId: id, aiProductType: type };
      url = apis.doctorReviewRecord(post);
    }

    url.then(result => {
      if (result.code === '0') {
        let canReview = result.data[0].canReview;
        let doctorRemark = result.data[0].doctorRemark || '';

        let [res, ids] = [[], []];
        result.data.forEach((item, index) => {
          const parentCode = parseInt(item.parentResultCode);
          const resCode = parseInt(item.resultCode);
          res.push({ key: index, value: [parentCode, resCode] });
          ids = ids.concat([parentCode, resCode]);
        });

        let status = parseInt(result.data[0].status || 0);
        let addMoreReview = true;
        if (ids.join(',').indexOf('43,44') >= 0 || status <= 1)
          addMoreReview = false;
        this.setState({
          textAreaValue: doctorRemark,
          reviewRes: res,
          reviewDoctorName: result.data[0].boxUserName,
          canReview,
          index: res.length,
          reportStatus: result.data[0].status,
          addMoreReview,
          status,
        });
        this.setDoctorConfigsDisabled();
      } else {
        this.setState({ canSeeReview: false });
        // message.error(result.message);
        if (result.code === '1009') this.props.history.push('/login');
      }
    });
  };

  getDoctorReviewRecordHis = () => {
    const { id, type, from } = this.state;
    let [post, url] = [{}, ''];
    if (from === 'aiproduct') {
      post = { ...post, id };
      url = apis.doctorReviewRecordHis4Study(post);
    } else {
      post = { ...post, id, type };
      url = apis.doctorReviewRecordHis(post);
    }

    url.then(result => {
      if (result.code === '0') {
        this.setState({ reviewRecordHis: result.data });
      } else {
        if (result.code === '1009') {
          message.error(i18n.t('pleaseLogin'));
          this.props.history.push('/login');
        }
      }
    });
  };

  setPrintContent = () => {
    const { id, type, token, report } = this.state;
    this.setState({ printDicomId: id });
    apis.getTemplateReport4Study(id, type, token).then(res => {
      if (res.code === '0') {
        const result = res.data;

        this.setState({
          report: { ...report, ...result },
        });
      } else {
        if (res.code === '1009' && this.props.history)
          this.props.history.push('/login');
        this.setState({ canPrint: false });
      }
    });
  };

  handleToggle = () => {
    const { reviewHistoryToggle } = this.state;
    this.setState({ reviewHistoryToggle: !reviewHistoryToggle });
  };

  addSuggestion = () => {
    let index = this.state.index;
    const res = this.state.reviewRes;
    res.push({ key: index, value: [] });
    this.setState({ reviewRes: res, index: index + 1 });
    this.setDoctorConfigsDisabled();
  };

  handelDelete = index => {
    const resList = this.state.reviewRes;
    for (let i = 0; i < resList.length; i++) {
      if (index === resList[i].key) resList.splice(i, 1);
    }
    this.setState({ reviewRes: resList });
    this.setDoctorConfigsDisabled();
  };

  suggestChange = (key, value) => {
    const { confirm } = Modal;
    const _this = this;

    let addMoreReview = value.join(',') === '43,44' ? false : true;

    this.setState({ addMoreReview });

    const resList = this.state.reviewRes;
    let flag = false;
    for (let i = 0; i < resList.length; i++) {
      if (resList[i].value.join('') === value.join('')) flag = true;
    }
    if (flag) {
      confirm({
        title: '已经存在相同的审核内容，是否需要合并？',
        okText: '是',
        cancelText: '否',
        onOk() {
          resList.forEach((item, index) => {
            if (item.key === key) resList.splice(index, 1);
          });

          _this.setState({ reviewRes: resList });
        },
        onCancel() {
          resList.forEach(item => {
            if (item.key === key) item.value = [];
          });

          _this.setState({ reviewRes: resList });
        },
      });
    } else {
      for (let i = 0; i < resList.length; i++) {
        if (key === resList[i].key) resList[i].value = value;
      }

      this.setState({ reviewRes: resList });
    }

    this.setDoctorConfigsDisabled();
  };

  setDoctorConfigsDisabled = () => {
    const { reviewRes, doctorConfigs } = this.state;
    if (reviewRes.length > 1) {
      reviewRes.forEach(item => {
        if (item.value.indexOf(43) >= 0) {
          doctorConfigs.forEach(item => {
            if (item.id !== 43) item.disabled = true;
            else item.disabled = false;
          });
        } else {
          doctorConfigs.forEach(item => {
            if (item.id === 43) item.disabled = true;
            else item.disabled = false;
          });
        }
      });
    } else {
      doctorConfigs.forEach(item => {
        item.disabled = false;
      });
    }
    this.setState({ doctorConfigs });
  };

  reportReview = () => {
    const w = window.screen.width - 10;
    const h = window.screen.height - 105;
    const { id, type, token } = this.state;
    let url = `/previewreport/${id}/${type}`;
    if (token) url += `?token=${token}`;

    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;
    window.open(url, 'report', str);
  };

  setDoctorReviewStatus = () => {
    const { id, from } = this.state;
    if (from === 'aiproduct') {
      apis.setDoctorReviewStatus4Study(id, '3');
    } else {
      apis.setDoctorReviewStatus(id, '3');
    }
  };

  getReviewGroups = () => {
    const { TextArea } = Input;
    const { canReview, reviewDoctorName, reviewRecordHis } = this.state;
    const { doctorConfigs, reviewRes, canSeeReview, reportStatus } = this.state;
    let { addMoreReview, from1, type, canPrint, from } = this.state;
    const { status, isLoading, reviewHistoryToggle } = this.state;
    if (!canSeeReview) return;

    if ((status === -2 || status > 1) && canPrint) canPrint = true;

    const reviewClass = classNames({
      'review-group': true,
      disabled: !canReview,
    });
    if (from === undefined) return null;
    return (
      <div className={reviewClass}>
        <div
          className="history-content"
          style={{ display: reviewHistoryToggle ? '' : 'none' }}
        >
          <Button
            type="link"
            className="history-close"
            onClick={this.handleToggle}
          ></Button>
          <Timeline className="history-list">
            {reviewRecordHis.length > 0 ? (
              reviewRecordHis.map((item, index) => {
                return (
                  <Timeline.Item key={index}>
                    <span className="time">{formatDA(item.updateTime)}</span>
                    <div>
                      {i18n.t('reviewedByDr')}
                      {item.boxUserName}
                    </div>
                    <div className="radio">{item.diseaseNames}</div>
                    <div className="history-cnt">{item.doctorRemark}</div>
                  </Timeline.Item>
                );
              })
            ) : (
              <div className="no-history">{i18n.t('noHistory')}</div>
            )}
          </Timeline>
        </div>
        <div className="title">
          {i18n.t('seniorRadiologistReview')}
          <Button
            type="link"
            className={`report-status${reportStatus >= '2' ? ' success' : ''}`}
          >
            {reportStatus === '0' && <>{shalouIcon} 待审核</>}
            {reportStatus === '1' && <>... 审核中</>}
            {reportStatus === '2' && (
              <>
                <Icon type="check" /> 已审核
              </>
            )}
            {reportStatus === '3' && (
              <>
                <Icon type="check" /> 已打印
              </>
            )}
            {reportStatus === '-2' && <>无需审核</>}
          </Button>
        </div>
        <div className="content">
          <div className="suggest-box">
            <div>
              {reviewRes.map((item, index) => {
                return (
                  <div className="item" key={index}>
                    <Cascader
                      fieldNames={{
                        label: 'diseaseName',
                        value: 'id',
                        children: 'childs',
                      }}
                      options={doctorConfigs}
                      onChange={() => this.suggestChange(item.key)}
                      placeholder="请选择诊断建议"
                      value={item.value}
                      defaultValue={item.value}
                      allowClear={false}
                      disabled={!canReview || from1 !== 'aireview'}
                      style={{ width: '335px' }}
                    />
                    {canReview &&
                    from1 === 'aireview' &&
                    reviewRes.length > 1 ? (
                      <Button
                        type="primary"
                        shape="circle"
                        icon="minus"
                        className="suggest-del"
                        size="small"
                        onClick={() => this.handelDelete(item.key)}
                      ></Button>
                    ) : null}
                  </div>
                );
              })}
            </div>
            {canReview && from1 === 'aireview' && addMoreReview ? (
              <div className="suggest-button">
                <Button
                  className="btn-plus-review"
                  type="primary"
                  onClick={this.addSuggestion}
                >
                  <Icon type="plus-circle" theme="filled" />
                  增加审核
                </Button>
              </div>
            ) : null}
          </div>
        </div>
        <div className="content report-text">
          <TextArea
            rows={6}
            placeholder={i18n.t('enterImpression')}
            disabled={!canReview || from1 !== 'aireview'}
            onChange={this.textAreaOnChange}
            value={this.state.textAreaValue}
            style={{ width: '335px' }}
          />
        </div>
        <div className="reviewed-by" style={{ width: '335px' }}>
          {reviewDoctorName ? (
            <span>
              <span style={{ color: '#9EBBC3' }}>
                {i18n.t('reviewedByDr')}&nbsp;
              </span>
              {reviewDoctorName}
            </span>
          ) : null}
        </div>
        <div className="report-btns">
          {isLoading && (
            <div className="spin-box-bg">
              <Spin indicator={<Icon type="loading" spin />} />
            </div>
          )}

          {reportStatus >= '2' ? (
            <Button
              type="link"
              className="history-link"
              onClick={this.handleToggle}
            >
              <Icon type="clock-circle" theme="filled" />
              {i18n.t('history')}
            </Button>
          ) : null}
          {canReview && from1 === 'aireview' ? (
            <>
              <Button className="btn-submit-report" onClick={this.saveReview}>
                <img alt="" src={btnSubmit} />
                &nbsp; 提交审核意见
              </Button>
              {reportStatus === '1' ? (
                <Button type="danger" onClick={this.giveupReview}>
                  <Icon type="stop" theme="filled" />
                  放弃审核
                </Button>
              ) : null}
            </>
          ) : null}
          {type === '11' ? (
            <>
              <Button
                className="btn-review"
                disabled={canPrint ? false : true}
                onClick={this.reportReview}
              >
                <Icon type="eye-invisible" theme="filled" />
                预览报告
              </Button>
              <ReactToPrint
                trigger={() => (
                  <Button
                    className="btn-print"
                    disabled={canPrint ? false : true}
                  >
                    <Icon type="printer" theme="filled" />
                    打印报告
                  </Button>
                )}
                content={() => this.componentRef}
                onAfterPrint={() => {
                  this.setDoctorReviewStatus();
                }}
              />
            </>
          ) : null}

          <div style={{ display: 'none' }}>
            <div ref={el => (this.componentRef = el)}>
              <ConnectedPrintReport
                report={this.state.report}
                printDicomId={this.state.printDicomId}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  getAIReports = () => {
    let { qcResult } = this.state;
    if (!qcResult.unpassedreasons || !qcResult.passedreasons) return;

    let unPassed = JSON.parse(qcResult.unpassedreasons);
    let passed = JSON.parse(qcResult.passedreasons);
    const result = [];

    for (let i in unPassed) {
      let content = unPassed[i];
      content = content.split(',');
      content.forEach((item, index) => {
        result.push(
          <p className="error" key={'unpassed-' + i + index}>
            {item}
          </p>
        );
      });
    }
    for (let i in passed) {
      let content = passed[i];
      content = content.split(',');
      content.forEach((item, index) => {
        result.push(<p key={'passed-' + i + index}>{item}</p>);
      });
    }

    return (
      <div className="review-group">
        <div className="title">{i18n.t('AIQCreport')}</div>
        <div className="report-content">{result}</div>
      </div>
    );
  };

  showHeatMap = (heatmap, studyUid) => {
    this.props.showHeatMap(heatmap, studyUid);
  };

  getChart = () => {
    const { type } = this.state;
    const data = this.getDataView();
    return (
      <Chart
        height={type === '6' ? 260 : 360}
        data={data}
        scale={{ value: { alias: '分数', min: 0, max: 100 } }}
        padding={[20, 22, 42, 76]}
        background={{
          fill: '#262F41', // 图表背景色
          radius: 5, // 图表圆角大小
        }}
        style={{ margin: 10 }}
        forceFit
        onIntervalClick={evt => {
          const context = { ...this.props.context };
          const data = evt.data;
          if (data) {
            const name = data._origin['name'];
            context.activeId = name;
            context.opacity = 100;
            this.props.setHeatmapContext(context);
          }
        }}
        onAxisLabelClick={evt => {
          const context = { ...this.props.context };
          const text = evt.target._attrs.text;
          let name = '';
          for (let i in this.keyLabelMap) {
            if (text === i18n.t(this.keyLabelMap[i])) name = i;
          }
          context.activeId = name;
          context.opacity = 100;
          this.props.setHeatmapContext(context);
        }}
      >
        <Coord transpose />
        <Axis
          name="type"
          label={{
            offset: 8,
            textStyle: { fill: '#95B7DA', fontSize: 12 },
            rotate: -50,
          }}
        />
        <Axis
          name="value"
          label={{
            offset: 16,
            textStyle: { fill: '#9ccef9', fontSize: 12 },
          }}
          line={{ lineWidth: 1 }}
        />
        <Tooltip />
        <Geom
          type="interval"
          position="type*value"
          size={20}
          color={[
            'type',
            ['#c2d3e4', '#9cc0e6', '#6ea8e6', '#3e8fe6', '#0d80e2'],
          ]}
        />
        <Guide>
          <Line
            start={['50%', '0%']}
            end={['50%', '100%']}
            lineStyle={{ stroke: '#f00', lineDash: [0, 2, 2], lineWidth: 1 }}
          />
        </Guide>
      </Chart>
    );
  };
  getWarningResult = data => {
    let { reportStatus, reviewRes } = this.state;
    const viralPneumonia = data.filter(item => item.name === 'viral_pneumonia');
    let number;
    let res = {};
    if (viralPneumonia.length > 0) number = viralPneumonia[0].value;
    let reviewList = [];
    reviewRes.forEach(item => {
      reviewList = reviewList.concat(item.value);
    });
    if (reportStatus === '2') {
      //已审核
      if (reviewList.indexOf(44) >= 0) {
        res = number > 50 ? center : low;
      } else if (reviewList.indexOf(60) >= 0) {
        res = high;
      } else {
        res = number > 50 ? center : number <= 50 ? low : loading;
      }
    } else {
      //未审核
      res = number > 50 ? center : number <= 50 ? low : loading;
    }
    return res;
  };

  getWarningTip = () => {
    const scData = this.props.scoresData || {};
    const scores = scData.scores || [];
    const { type } = this.state;
    let warningData = [];

    if (type === '6') warningData = this.getViralPneumoniaScores(scores);
    const warningResult = this.getWarningResult(warningData);
    return (
      <div className="warning-tip">
        <p>疑似病毒性肺炎风险等级：</p>
        <p className={warningResult.color + ' tip'}>
          {warningResult.color !== 'white' ? (
            <Icon type="warning" theme="filled" />
          ) : null}
          &nbsp;&nbsp; {warningResult.text}
        </p>
      </div>
    );
  };
  render() {
    const scData = this.props.scoresData || {};
    const { type, from, from1 } = this.state;

    const userRole = window.store.getState().api.user.info.operationAuths || '';
    const { isOtherBody } = this.state;
    if (from === 'screening') {
      //智能筛查审核
      return (
        <ConnectedScreening
          showHeatMap={this.showHeatMap}
          showScreening={this.props.showScreening}
          tubeStudyDetail={this.props.tubeStudyDetail}
        />
      );
    } else if (from1 === 'aireport') {
      //AI应用-AI报告
      if (isOtherBody === 'true') return null;
      if (from1 === 'aireport' || userRole.indexOf('A') >= 0) {
        return (
          <ConnectedAiReport
            aiReportChanged={this.props.aiReportChanged}
            dicomIds={this.props.dicomIds}
            selectedData={this.props.selectedData}
            thumbIndex={this.props.thumbIndex}
            doctorConfigs={this.state.doctorConfigs}
          />
        );
      } else {
        return null;
      }
    } else if (from === 'report') {
      //远程诊断报告
      return (
        <ConnectedImageQC
          applicationInfo={this.props.applicationInfo}
          followupList={this.props.followupList}
        />
      );
    } else if (from === 'aiproduct' && from1 !== 'aireview') {
      //AI应用-肺结核、常见肺部疾病、病毒性肺炎
      return (
        <>
          {/* 病毒性肺炎提示 */}
          {type === '6' && <>{this.getWarningTip()}</>}
          {this.getChart()}
          {this.getReviewGroups()}
        </>
      );
    } else if (from === 'aiproduct' && from1 === 'aireview') {
      return <>{this.getReviewGroups()}</>;
    } else {
      if (isOtherBody === 'true') return null;
      return !scData || scData.loading ? (
        <div className="loading-spin">
          <Spin size={'large'} />
        </div>
      ) : scData.error ? (
        <>
          <Result
            status="error"
            title="评分请求失败！"
            subTitle={scData.error}
          />
          {(type === '6' || type === '9') && this.getReviewGroups()}
          {type === '8' && this.getAIReports()}
        </>
      ) : (
        <>
          {type === '6' && <>{this.getWarningTip()}</>}
          {from1 !== 'aireview' && <>{this.getChart()}</>}

          {(type === '6' || type === '9' || type === '11') &&
            this.getReviewGroups()}
          {type === '8' && this.getAIReports()}
        </>
      );
    }
  }
}

export default withTranslation('Common')(BarCharts);
